import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { config, getAssetUrl } from '../../../utils/config';
import sendDatadogEvent from '../../../utils/sendDatadogEvent';
import { pushTrackingEvent } from '../../../utils/tracking';
import SubHeadline from '../SubHeadline';
import './style.scss';

const GeneralError = ({ error }: { error?: Error }) => {
  useEffect(() => {
    pushTrackingEvent({
      event: 'content_view',
      content_name: `${window.location.pathname}/general-error`,
      search: window.location.search || null,
      app_version: 'v3',
      appId: config.appId,
      page_type: 'checkout:error_loading_component'
    });
    try {
      sendDatadogEvent('checkout-error', error);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <div className="general-error">
      <img src={getAssetUrl('common/gears.svg')} alt="error" className="general-error__img" />
      <SubHeadline>
        <FormattedMessage id="errors.technicalDifficulties" />
      </SubHeadline>
      <p>
        <FormattedMessage id="errors.refresh" />
      </p>
      <p>
        <FormattedMessage id="errors.contactUs" />
      </p>
    </div>
  );
};

export default GeneralError;
